module.exports = __webpack_public_path__ + "0a39ccef4b8047220b2dad34a6cee8d7.svg";